$(document).ready(function(){
  
$(".t4s-swatch__list .t4s-swatch__item").click(function() {
  var selected_size = $(this).attr('data-value');
  localStorage.setItem('size_value', selected_size);
  var currentTime = new Date().getTime();
  localStorage.setItem('size_set_time', currentTime);
});

setInterval(function() {
  var storedTime = localStorage.getItem('size_set_time');
  if (!storedTime) {
    return;  
  }
  
  var currentTime = new Date().getTime();
  
  if (currentTime - storedTime > 3600000) {  
    localStorage.removeItem('size_value');
    localStorage.removeItem('size_set_time');
  }
}, 1000);  


var page_type = $('body').attr('data-page');    
var store_page = localStorage.getItem('pre_page'); 
if (store_page === null) {
  localStorage.setItem('pre_page', page_type);
} 
if (store_page == page_type) {
    var store_size = localStorage.getItem('size_value');
  if ($(".t4s-swatch__list").length) {
    $(".t4s-swatch__list .t4s-swatch__item").each(function(){
      var size_value = $(this).attr('data-value');
      if(store_size == size_value){
        var item = $(this);
        var intervalId = setInterval(function() {
          item.trigger('click');
          $(".t4s-swatch__title .t4s-swatch__current").show();
          $(".remove-default-selected-variant").hide(); 
          $(".main-add-to-cart-button").show(); 
          var updated_size = $(".t4s-swatch__list .is--selected").attr('data-value');
          if (store_size == updated_size) {
            clearInterval(intervalId);
          }
        }, 0001); 
      }
    });
  }
} else {
  localStorage.removeItem('pre_page');  
  localStorage.setItem('pre_page', page_type); 

    var intervalId;
  intervalId = setInterval(function() {
    $(".t4s-swatch__list .t4s-swatch__item").each(function(){
      $(this).removeClass('is--selected');
    });
    $(".t4s-swatch__title .t4s-swatch__current").text('');
  }, 0001); 
  
  $(".t4s-swatch__list .t4s-swatch__item").click(function(){
    $(".remove-default-selected-variant").hide(); 
    $(".main-add-to-cart-button").show(); 
    $(".t4s-swatch__title .t4s-swatch__current").show();
    clearInterval(intervalId); 
  });

  $('body').on('click', '.remove-default-selected-variant', function() {
    $('body').addClass('variant-restriction-popup');
    $(".product-select-size-block").show();
  });
  
    $('body').on('click', '.product-select-size-block .close-icon', function() {
    $(".product-select-size-block").hide();
       $('body').removeClass('variant-restriction-popup')
  });
  
}


});
